/* DinoStudio — product page interactions (Shopify variants + AJAX cart). */
(function () {
  'use strict';

  function feedback(btn, msg) {
    if (!btn || btn.dataset.busy) return; btn.dataset.busy = '1';
    var sp = btn.querySelector('span') || btn, prev = sp.textContent;
    sp.textContent = msg; btn.style.filter = 'brightness(1.13)';
    setTimeout(function () { sp.textContent = prev; btn.style.filter = ''; delete btn.dataset.busy; }, 1500);
  }

  var vidInput = document.getElementById('pd-variant-id');
  function selectedVid() { return vidInput ? vidInput.value : null; }

  function bindSizes() {
    var wrap = document.querySelector('.pd__sizes');
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.size'); if (!b) return;
      wrap.querySelectorAll('.size').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); s.setAttribute('aria-checked', 'false'); });
      b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-checked', 'true');
      if (vidInput && b.dataset.vid) vidInput.value = b.dataset.vid;
    });
  }

  function bindSizeHelp() {
    var help = document.getElementById('sizehelp');
    if (!help) return;
    help.addEventListener('click', function () {
      var sg = document.getElementById('sizeguide');
      if (sg) { sg.open = true; sg.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  function bindBuyBox() {
    var form = document.getElementById('pd-form');
    var addBtn = document.getElementById('add');
    var buyBtn = document.getElementById('buy');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!window.CART) { form.submit(); return; }
        window.CART.addId(selectedVid(), 1).then(function () { window.CART.open(); });
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (!window.CART) return;
        feedback(buyBtn, 'Redirecting…');
        window.CART.addId(selectedVid(), 1).then(function () { window.location.href = '/checkout'; });
      });
    }
  }

  /* ---- sticky add-to-cart bar ---- */
  function bindSticky() {
    var bar = document.getElementById('stickybar'), actions = document.getElementById('pd-actions');
    if (!bar || !actions) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { threshold: 0 });
      io.observe(actions);
    }
    var sb = document.getElementById('sb-add');
    if (sb) sb.addEventListener('click', function () {
      if (!window.CART) return;
      window.CART.addId(selectedVid(), 1).then(function () { window.CART.open(); });
    });
  }

  /* ---- frequently bought together ---- */
  function updateBundle() {
    var fbt = document.getElementById('fbt'); if (!fbt) return;
    var cks = fbt.querySelectorAll('.fbt__ck');
    var subtotal = 0, n = 0;
    cks.forEach(function (c) { if (c.checked) { subtotal += parseFloat(c.dataset.price) || 0; n++; } });
    var bundled = n >= 2 ? subtotal * 0.9 : subtotal;
    var wasEl = document.getElementById('fbt-was'), nowEl = document.getElementById('fbt-now'),
        saveEl = document.getElementById('fbt-save'), addBtn = document.getElementById('fbt-add');
    if (nowEl) nowEl.textContent = '$' + bundled.toFixed(2);
    if (wasEl) { wasEl.textContent = n >= 2 ? '$' + subtotal.toFixed(2) : ''; wasEl.style.display = n >= 2 ? '' : 'none'; }
    if (saveEl) saveEl.style.display = n >= 2 ? '' : 'none';
    if (addBtn) { var sp = addBtn.querySelector('span'); if (sp) sp.textContent = n ? ('Add ' + n + ' item' + (n === 1 ? '' : 's') + ' to cart') : 'Select an item'; addBtn.disabled = n === 0; }
  }
  function bindFbt() {
    var fbt = document.getElementById('fbt'); if (!fbt) return;
    fbt.addEventListener('change', function (e) { if (e.target.classList.contains('fbt__ck')) updateBundle(); });
    fbt.addEventListener('click', function (e) {
      var b = e.target.closest('#fbt-add'); if (!b || !window.CART) return;
      var lines = [];
      fbt.querySelectorAll('.fbt__ck').forEach(function (c) { if (c.checked && c.dataset.vid) lines.push({ id: c.dataset.vid, quantity: 1 }); });
      if (lines.length) window.CART.addMany(lines).then(function () { window.CART.open(); });
    });
    updateBundle();
  }

  /* ---- image gallery: thumbs, hover-magnify, lightbox ---- */
  function bindGallery() {
    var gallery = document.getElementById('pd-gallery');
    if (!gallery) return;
    var stage = document.getElementById('pd-stage');
    var imgs = stage ? stage.querySelectorAll('.pd__img') : [];
    var thumbs = gallery.querySelectorAll('.pd__thumb');
    var count = imgs.length;
    var current = 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      if (i < 0 || i >= count) return;
      current = i;
      imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        var on = String(k) === String(i);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      var go = function () { show(parseInt(t.dataset.idx, 10)); };
      t.addEventListener('click', go);
      t.addEventListener('mouseenter', go);
    });

    /* desktop hover-magnify — track pointer as transform-origin */
    if (stage && window.matchMedia('(hover:hover) and (pointer:fine)').matches && !reduce) {
      stage.addEventListener('mouseenter', function () { stage.classList.add('is-zooming'); });
      stage.addEventListener('mouseleave', function () {
        stage.classList.remove('is-zooming');
        imgs.forEach(function (im) { im.style.transformOrigin = 'center'; });
      });
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        var act = imgs[current];
        if (act) act.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    /* ---- lightbox ---- */
    var lb = document.getElementById('pd-lightbox');
    if (!lb) return;
    var lbImgs = lb.querySelectorAll('.pd-lightbox__img');
    var lbStage = document.getElementById('lb-stage');
    var lbCur = 0, lastFocus = null;

    function lbShow(i) {
      if (i < 0) i = count - 1; if (i >= count) i = 0;
      lbCur = i;
      lbImgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); im.classList.remove('is-zoomed'); im.style.transform = ''; });
      var dots = lb.querySelectorAll('.pd-lightbox__dot');
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function openLb(i) {
      lastFocus = document.activeElement;
      lbShow(i);
      lb.hidden = false; lb.classList.add('show');
      if (!reduce) { lb.classList.add('animate'); setTimeout(function () { lb.classList.remove('animate'); }, 360); }
      document.body.style.overflow = 'hidden';
      var c = document.getElementById('lb-close'); if (c) c.focus();
      document.addEventListener('keydown', onKey);
    }
    function closeLb() {
      lb.classList.remove('show'); lb.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight') lbShow(lbCur + 1);
      else if (e.key === 'ArrowLeft') lbShow(lbCur - 1);
    }

    if (stage) stage.addEventListener('click', function () { openLb(current); });
    var cBtn = document.getElementById('lb-close'); if (cBtn) cBtn.addEventListener('click', closeLb);
    var pBtn = document.getElementById('lb-prev'); if (pBtn) pBtn.addEventListener('click', function () { lbShow(lbCur - 1); });
    var nBtn = document.getElementById('lb-next'); if (nBtn) nBtn.addEventListener('click', function () { lbShow(lbCur + 1); });
    lb.querySelectorAll('.pd-lightbox__dot').forEach(function (d) {
      d.addEventListener('click', function () { lbShow(parseInt(d.dataset.idx, 10)); });
    });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });

    /* click-to-zoom + pan on the active lightbox image */
    lbImgs.forEach(function (im) {
      im.addEventListener('click', function (e) {
        e.stopPropagation();
        var z = im.classList.toggle('is-zoomed');
        if (!z) { im.style.transform = ''; return; }
        panZoom(im, e);
      });
      im.addEventListener('mousemove', function (e) { if (im.classList.contains('is-zoomed')) panZoom(im, e); });
    });
    function panZoom(im, e) {
      var r = im.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      im.style.transformOrigin = x + '% ' + y + '%';
    }

    /* swipe navigation (mobile) */
    var sx = 0, sy = 0;
    lbStage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    lbStage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) lbShow(lbCur + (dx < 0 ? 1 : -1));
      else if (dy > 70 && Math.abs(dy) > Math.abs(dx)) closeLb();
    }, { passive: true });
  }

  function init() { bindSizes(); bindSizeHelp(); bindBuyBox(); bindSticky(); bindFbt(); bindGallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
